import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import NavigatorMain from './NavigatorMain';

 class iframeWeb extends Component{
	constructor(props) {
	    super(props);
	    this.state = {
	    };
  	}
  	componentDidMount(){
	        // setTimeout(function () { //延迟1s，为了确保iframe已经被加载完成，由于是动态创建的iframe，无法使用onload监听
	        //    onLoad();
	        // },1000);
  	}
  	goBack(){
    	hashHistory.goBack();
  	}
	render(){
		let url = this.props.location.query.url;
		return(
			<div>
				<NavigatorMain>
		          <div className="header">
                    <div style={{ WebkitFlex:1 }}><span className="headerLeftBtn" onClick={ ()=> this.goBack() }></span></div>
                    <div style={{ WebkitFlex:2, textAlign:'center', fontSize:"0.3rem" }}></div>
                    <div style={{ WebkitFlex:1, textAlign:'right', fontSize:"0.28rem", paddingRight:'13px' }}></div> 
		          </div>
         		</NavigatorMain>
         		{/* <div style={{height:44}}></div> */}
				<iframe ref="iframe" id="postMessage" src={ url } frameborder="0" width="100%" height={window.screen.height-44} style={{border:0}}>
	         		
	         	</iframe>
         	</div>
		)
	}
}
function mapStateToProps(state, ownProps) {
    return {
      
    }
  }
  
  export default connect(mapStateToProps)(iframeWeb);


// WEBPACK FOOTER //
// ./src/components/iframeWeb.js